module.exports = __webpack_public_path__ + "static/media/agenda-arrow.88fe118b.svg";